import { PageMeta } from '@components/page-meta';
import PageContainer from '@components/PageContainer';
import { RouteComponentProps } from '@reach/router';
import { SourceType } from 'src/modules/generated/api';

import PackageDetail from '../../../../containers/PackageDetail';

type PackagePageProps = RouteComponentProps<{ source: SourceType; packageId: string }>;

const PackagePage = ({ source, packageId }: PackagePageProps) => (
  <>
    <PageMeta title="common.package" />
    <PageContainer maxWidth="xl">
      <PackageDetail source={source as SourceType} packageId={packageId as string} isDetailPage />
    </PageContainer>
  </>
);

export default PackagePage;
